import isValid from 'date-fns/isValid';

const text = (row1, row2, columnId) => {
    const getValue = (row) => (typeof row.values[columnId] === 'string' ? row.values[columnId] : '');
    const value1 = getValue(row1);
    const value2 = getValue(row2);
    return value1.localeCompare(value2, undefined, { sensitivity: 'base' });
};
const number = (row1, row2, columnId) => {
    const rowValue1 = row1.values[columnId];
    const rowValue2 = row2.values[columnId];
    return Number(rowValue1) - Number(rowValue2);
};
const datetime = (row1, row2, columnId) => {
    const getValue = (row) => {
        const rowValue = new Date(row.values[columnId]);
        return isValid(rowValue) ? rowValue.getTime() : 0;
    };
    const value1 = getValue(row1);
    const value2 = getValue(row2);
    return value1 - value2;
};

export { datetime, number, text };
//# sourceMappingURL=sorting.js.map
